module.exports = __webpack_public_path__ + "img/U_1.5f1d4f7e.png";